<mat-form-field appearance="outline" class="w-100">
    <app-icon name="search" size="xs" class="mat-select-search-icon"></app-icon>
    <input 
        #searchAddressInput 
        matInput 
        type="text" 
        [placeholder]="placeholder" 
        [matAutocomplete]="auto"
        (keydown.enter)="$event.preventDefault()"
        class="ml-2"
    />

    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectPlace($event)">
        <mat-option *ngFor="let item of predictions" [value]="item">{{item.description}}</mat-option>
    </mat-autocomplete>
</mat-form-field>

<app-state-section [state]="sectionState"></app-state-section>